import React, { PropsWithChildren, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FolderIcon from '@material-ui/icons/Folder';
import { ButtonBase, TextField } from '@material-ui/core';
import { FolderMenu } from './FolderMenu';
import colors from '../../../../../styles/colors';

export interface FolderProps {
  folder: {
    id: number;
    name: string;
    isEditMode: boolean;
  };
  handleFolderSetEditMode: (folderId: number) => any;
  handleFolderCreation: (name: string, folderId?: number) => any;
  handleFolderDelete(folderId: number): any;
  removeFolderItem(): any;
}

const useStyles = makeStyles({
  root: {
    border: '1px solid #DDDDDD',
    borderRadius: '4px',
    padding: '.8rem 1.2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    textAlign: 'left'
  },
  text: {
    marginLeft: '10px',
    textOverflow: 'ellipsis',
    paddingRight: '10px',
    fontSize: '.9rem'
  }
});

const FolderItem: React.FC<FolderProps> = (
  props: PropsWithChildren<FolderProps>
) => {
  const classes = useStyles();
  const {
    removeFolderItem,
    handleFolderCreation,
    handleFolderSetEditMode,
    handleFolderDelete,
    folder
  } = props;
  const { name, isEditMode } = folder;
  const ref = useRef(null);

  const handleClick = (e: Event) => {
    // @ts-ignore
    if (ref?.current?.contains(e.target)) {
      return;
    }
    if (isEditMode) {
      if (folder.id) {
        handleFolderSetEditMode(folder.id);
      } else {
        removeFolderItem();
      }
    }
  };

  React.useEffect(() => {
    // add when mounted
    document.addEventListener('mousedown', handleClick); // return function to be called when unmounted
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [isEditMode]);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <ButtonBase className={classes.root}>
        <FolderIcon style={{ color: colors.primary }} color="action" />
        {isEditMode ? (
          <TextField
            placeholder={'Enter folder name...'}
            defaultValue={folder.id && folder.name}
            focused={isEditMode}
            style={{ margin: '0 10px' }}
            onKeyDown={(e: any) => {
              if (e.key === 'Enter') {
                e.stopPropagation();
                handleFolderCreation(e.target.value, folder.id);
              }
            }}
          />
        ) : (
          <span className={classes.text}>{name}</span>
        )}
      </ButtonBase>
      {folder.id && (
        <div style={{ position: 'absolute', top: 1, right: 1 }}>
          <FolderMenu
            handleEdit={() => handleFolderSetEditMode(folder.id)}
            handleDelete={() => handleFolderDelete(folder.id)}
            folderId={folder.id}
          />
        </div>
      )}
    </div>
  );
};

export default FolderItem;
